import { render, staticRenderFns } from "./koulutusjakso-form.vue?vue&type=template&id=4f885120&"
import script from "./koulutusjakso-form.vue?vue&type=script&lang=ts&"
export * from "./koulutusjakso-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports